(() => {
  const swiper = document.querySelector(".js-reassurance-slider__swiper");
  const slides = document.querySelectorAll(".js-reassurance-slider__slide");
  const autoplay = { delay: parseInt(swiper.dataset.delay, 10), disableOnInteraction: false };

  new Swiper(".js-reassurance-slider__swiper", {
    autoplay,
    loop: slides > 1,
    pagination: {
      el: ".js-reassurance-slider__swiper-pagination",
      clickable: true
    }
  });
})();
